import React, { Component } from 'react';

class DealerTiles extends Component {

    constructor(props) {
        super(props);
    }

        
    renderTiles(dealers, selectedDealer, handleTileClick, title) {
        
        const props = {};
        props.className = 'dealer-tiles';

        return (
            <div>
                <div className="popup-form__label popup-form__label--medium">{title}</div>
                <div className="popup-form__row">
                    <div className="popup-form__col">
                        <ul {...props}>
                            {dealers.map(dealer => {
                                let itemProps = {};
                        
                                let sourceProps = {};
                                let imgProps = {};
                                let bgProps = {
                                    style: {}
                                };

                                sourceProps.media = "(max-width: 820px)";
                                sourceProps.srcSet = `${dealer.data['dealership-details'].brand[0].data['brand-details']['logo-colour'].sizes.logo_240}`

                                imgProps.src = `${dealer.data['dealership-details'].brand[0].data['brand-details']['logo-colour'].sizes.nav_logos_m}`;
                                imgProps.alt = `The Brand Logo for ${dealer.post_title}`;
                                bgProps.style.backgroundImage = `url(${dealer.data['dealership-details']['nav-bg'].url})`

                                itemProps.className = 'dealer-tiles__item';
                                bgProps.className = 'dealer-tiles__bg';
                                if (selectedDealer == dealer.ID) {
                                    itemProps.className += ' dealer-tiles__item--selected';
                                    bgProps.className += ' dealer-tiles__bg--selected';
                                }

                                return (

                                    <li  {...itemProps} key={dealer.ID} onClick={() => {
                                        handleTileClick(dealer)
                                    }}>
                                        <span className="dealer-tiles__link">
                                            <div className="dealer-tiles__content">
                                                <picture className="dealer-tiles__logo">
                                                    <source {...sourceProps}/>
                                                    <img {...imgProps}/>
                                                </picture>
                                                <div className="dealer-tiles__text">{dealer.post_title}</div>
                                            </div>
                                            <div {...bgProps} ></div>
                                        </span>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { selectedRegion , selectedBrand, selectedDealer, handleTileClick, regions, brands, otherBrands, dealers, ...rest } = this.props;

        let allBrands = brands.concat(otherBrands);
        let currentBrand = null;
        let currentRegion = null;

        allBrands.forEach(brand => {
            if (brand.ID == selectedBrand) {
                currentBrand = brand;
            }
        })
        regions.forEach(region => {
            if (region.term_id == selectedRegion) {
                currentRegion = region;
            }
        })

        let licensedDealers = [];
        let additionalDealers = [];

        // merge lower hutt and welly regions


        dealers.forEach(region => {

            if (region.label == currentRegion.name) {

                region.options.forEach(dealer => {
                    let goodDealer = false;
                    if (dealer.dealer.data['service-brands'] && dealer.dealer.data['service-brands'].brand) {
                        if (dealer.dealer.data['service-brands'].brand.find(br => (br.ID == currentBrand.ID))) {
                            licensedDealers.push(dealer.dealer);
                            goodDealer = true;
                        }
                    }
                    if (dealer.dealer.data['service-brands'] && dealer.dealer.data['service-brands']['other-brand']) {
                        if (dealer.dealer.data['service-brands']['other-brand'].find(br => (br.ID == currentBrand.ID))) {
                            licensedDealers.push(dealer.dealer);
                            goodDealer = true;
                        }
                    }

                    if (!goodDealer) {
                        additionalDealers.push(dealer.dealer)
                    }
                })
            }
        })

        // Pull Brand dealer to first in list
        if (licensedDealers.length > 0 && currentBrand) {
            licensedDealers.sort((dealer) => {
                if (dealer.post_title.includes(currentBrand.post_title)) {
                    return -1
                } else {
                    return 1
                }
            })
        }
        // Pull Brand dealer to first in list
        if (additionalDealers.length > 0 && currentBrand) {
            additionalDealers.sort((dealer) => {
                if (dealer.post_title.includes(currentBrand.post_title)) {
                    return -1
                } else {
                    return 1
                }
            })
        }

        return (
            <div>
                <div className="popup-form__label popup-form__label--large popup-form__label--first">Select dealership</div>
                <div className="popup-form__label">Select one of our dealerships from the {currentRegion.name} region</div>
                {(licensedDealers.length > 0) ? this.renderTiles(licensedDealers, selectedDealer, handleTileClick, `Licensed ${currentBrand.post_title} servicing`) : ''}
                {this.renderTiles(additionalDealers, selectedDealer, handleTileClick, (licensedDealers.length > 0) ? `Additional service centres` : `Our service centres`)}
            </div>
        );
    }
}

export { DealerTiles };